import { asSingleStyleConfig } from '../../../../utils/theme';
var baseStyle = {
  border: '1px solid transparent',
  borderRadius: '4px',
  ':focus, :active': {
    bg: 'transparent',
    borderColor: 'blue.200',
    textDecoration: 'none',
    boxShadow: '0 0 3px 2px #4CAAF0',
    outline: 0
  }
};
export var LogoWrapper = asSingleStyleConfig({
  baseStyle
});